// store/slices/cartUI.slice.js
import { createSlice } from '@reduxjs/toolkit';

const cartUI = createSlice({
    name: 'cartUI',
    initialState: {
        addedToCartIndex: {},
        showCartButtons: false,
    },
    reducers: {
        setShowCartButtons: (state, action) => {
            state.showCartButtons = action.payload;
        },
        markItemAsAdded: (state, action) => {
            const index = action.payload;
            state.addedToCartIndex[index] = true;
        },
        unmarkItemAsAdded: (state, action) => {
            const index = action.payload;
            delete state.addedToCartIndex[index];
        },
        resetAddedToCart: (state) => {
            state.addedToCartIndex = {};
        }
    },
});

export const { markItemAsAdded, unmarkItemAsAdded, resetAddedToCart, setShowCartButtons } = cartUI.actions;
export default cartUI.reducer;
